import { PageResponseVm } from 'api/core/page-response.vm';
import { Type } from 'class-transformer';
import { IsString, ValidateNested } from 'class-validator';
import { ProductVm } from './product.vm';

export class GetProductsVm extends PageResponseVm<ProductVm, string> {
  @IsString()
  nextOffset: string;

  @Type(() => ProductVm)
  @ValidateNested({ each: true })
  objects: ProductVm[];
}
